import { useMutation } from "react-query";
import { RelatorioComposicaoReceitasHorizontalPdfResponse } from "../typings";

import { RelatorioComposicaoReceitasQueryParams } from "core/features/relatorios/conta-com-composicoes/typings";

import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioComposicaoReceitasHorizontalPdf(
  query: RelatorioComposicaoReceitasQueryParams
) {
  return useMutation<
    RelatorioComposicaoReceitasHorizontalPdfResponse,
    AxiosError
  >(
    [`/v1/relatorios/financeiro/composicao-receitas-horizontal/pdf`, query],
    async () => {
      const { data } =
        await http.get<RelatorioComposicaoReceitasHorizontalPdfResponse>(
          "/v1/relatorios/financeiro/composicao-receitas-horizontal/pdf",
          {
            params: query,
          }
        );

      return data;
    }
  );
}

export default useRelatorioComposicaoReceitasHorizontalPdf;
